<template>
  <a :href="article.article_url " target="_blank">
    <article
      class="surface1 rounded-2xl transition-all duration-300 hover:surface2 hover:transition-all hover:duration-300"
    >
      <div class="bg-gradient-to-tr from-brand-bright-green/20 to-primary/20 rounded-t-2xl block">
        <img
          v-if="article.image_url"
          :src="article.image_url"
          class="object-cover min-w-full h-[7rem] rounded-t-2xl block -z-10"
        />
      </div>
      <div class="py-2 px-4">
        <div>
          <p class="label-md text-primary">{{ article.subtitle }}</p>
        </div>
        <div>
          <h3 class="title-lg pt-2">{{ article.title }}</h3>
        </div>
      </div>
    </article>
  </a>
</template>

<script>
import Button from '@/Components/Button'
import { validateRequiredKeys } from '@/utilities.helpers.js'

export default {
  name: 'NewsCard',
  components: { Button },
  props: {
    article: {
      required: true,
      validator: value =>
        validateRequiredKeys(value, [
          'title',
          'subtitle',
          'description',
          'published_at',
          'article_url',
        ]),
    },
  },
  computed: {
    parsed_published_at() {
      const date = new Date(this.article.published_at * 1000)
      return `${date
        .getDate()
        .toString()
        .padStart(2, '0')}/${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}/${date.getFullYear()}`
    },
  },
}
</script>

<style></style>
